import cn from 'classnames';
import IconWrapper from '@components/ui/Icons';
import { CheckCircleIcon, ProhibitIcon } from '@phosphor-icons/react';

import styles from './FulfillmentStockLevelRow.module.scss';

export type FulfillmentStockLevel =
  | 'outOfStock'
  | 'low'
  | 'medium'
  | 'high'
  | null;

type FulfillmentStockLevelRowProps = {
  stockLevel: string | null;
  stockLevelMessage: string | null | undefined;
  fitContent?: boolean;
};

const FulfillmentStockLevelRow = ({
  stockLevel,
  stockLevelMessage,
  fitContent = false,
}: FulfillmentStockLevelRowProps) => {
  if (!stockLevelMessage) {
    return null;
  }

  return (
    <span
      className={cn(styles.stockLevelContainer, {
        [styles.fitContent]: fitContent,
      })}
    >
      {stockLevel === 'outOfStock' && (
        <ProhibitIcon size={20} color="var(--accents-sale-500)" weight="bold" />
      )}
      {stockLevel === 'low' && (
        <IconWrapper
          icon="fire"
          height={20}
          fill="var(--accents-popular-500)"
          classNames={styles.fireIcon}
          width={20}
        />
      )}
      {(stockLevel === 'medium' || stockLevel === 'high') && (
        <CheckCircleIcon size={20} weight="fill" color="var(--primary-500)" />
      )}
      <span className={styles.stockLevelMessage}>{stockLevelMessage}</span>
    </span>
  );
};

export default FulfillmentStockLevelRow;
